import { formatDateForInput } from "utils/helpers/dateHelper";
import DTextField from "components/common/DTextField";

export default function DateFieldRenderer({
    field,
    form,
    setForm,
    errors,
    showValidation
}) {
    const value = formatDateForInput(form[field.name]);

    return (
        <DTextField
            fullWidth
            margin="normal"
            type="date"
            label={field.label}
            value={value}
            required={field.required}
            error={showValidation && !!errors[field.name]}
            helperText={showValidation ? (errors[field.name] ?? "") : ""}
            slotProps={{
                inputLabel: {
                    shrink: true
                }
            }}
            sx={{ marginBottom: "unset", marginTop: "unset", margin: "4px" }}
            disabled={field.disabled}
            onChange={(event) =>
                setForm((prev) => ({
                    ...prev,
                    [field.name]: event.target.value
                }))
            }
        />
    );
}
